import { Button, Paper, Stack } from "@mui/material";
import usePrivatePlacements from "./hooks/usePrivatePlacements.ts";
import { GridColDef } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useEffect } from "react";
import usePrivatePlacementStore, { PrivatePlacement } from "../stores/private-placements.store.ts";
import { Moment } from "moment";

export default function NationalPrivatePlacements() {
  const { getPrivatePlacements } = usePrivatePlacements();
  const { placements } = usePrivatePlacementStore();
  useEffect(() => { getPrivatePlacements() }, []);

  const columns: GridColDef[] = [
    { field: 'id', headerName: '', align: "center" },
    { field: 'state', headerName: 'State', width: 70 },
    { field: 'issuer', headerName: 'Issuer', flex: 1 },
    { field: 'issue', headerName: 'Issue', flex: 1 },
    { field: 'tenor', headerName: 'Tenor', type: 'number', align: "right", valueGetter: (val: number) => val <= 0 ? null : val, valueFormatter: (val: number | null) => val == null ? "" : val.toFixed(2) + "Y", width: 70 },
    { field: 'finalMaturity', headerName: 'Final Maturity', valueFormatter: (val: Moment) => val.format("MM/DD/YYYY") },
    { field: 'parAmount', headerName: 'Par Amount', type: 'number', valueFormatter: (val: number) => val !== 0 ? '$' + val.toLocaleString('en-US') : "", align: "right" },
    { field: 'datedDate', headerName: 'Dated Date', valueFormatter: (val: Moment) => val.format("MM/DD/YYYY") },
    { field: 'proxyPricingDate', headerName: 'Proxy Pricing Date', valueFormatter: (val: Moment) => val.format("MM/DD/YYYY") },
    { field: 'taxDesignation', headerName: 'Tax Designation' },
    { field: 'securityCode', headerName: 'Security Code' },
    { field: 'coupon', headerName: 'Coupon', align: "right" },
    { field: 'purchaser', headerName: 'Purchaser' },
    { field: 'advisor', headerName: 'Advisor' },
    { field: 'bondCounsel', headerName: 'Bond Counsel' },
    { field: 'action', headerName: 'Source File', renderCell: (params) => <GridButton index={params.id as number} rows={placements} /> },
  ];

  return (
    <Stack direction="row" width="100%" p={2}>
      <Paper sx={{
        height: "calc(100vh - 200px)",
        width: 'calc(100vw - 50px)',
      }}>
        <DataGridPro
          rows={placements}
          columns={columns}
          filterMode="client"
          disableMultipleColumnsSorting={false}
          disableMultipleColumnsFiltering={false}
          sx={{ border: 0, width: '100%', maxWidth: '100%' }}
        />
      </Paper>
    </Stack>
  )
}

interface GridButtonProps {
  index: number,
  rows: PrivatePlacement[]
}

function GridButton({ index, rows }: GridButtonProps) {
  const url = rows[index - 1]["sourceFile"];
  const disabled = url === "";

  return (
    <Button
      variant="outlined"
      sx={{ width: "80px" }}
      disabled={disabled}
      onClick={() => window.open(url, '_blank', 'noopener,noreferrer')}
    >
      View
    </Button>
  )
}
